import React from 'react'
import { I18n } from '@front/volcanion'

import FormatUtils from '@front/squirtle/utils/format'

import { Box, Typography, Grid, Icon } from '@mui/material'
import { TextComponent, TextField } from '@front/squirtle'

const Row1 = ({ price, driver_price, voucher_amount, estimatedDelay, estimation_type = 'none', isManualPriceRequired, schedule_type, empty_fee, isLiveETA }) =>
  <Grid container spacing={1} size={12}>
    <Grid hidden={estimation_type !== 'special'} size={4}>
      <TextField
        label={I18n.t(`price.${estimation_type}`)}
        name='manual_price'
        InputProps={{
          endAdornment: <Typography sx={{ ml: 1, mb: 1 }}> {I18n.t('fiat.eur.sign')} </Typography>,
          inputProps: { style: { textAlign: 'right' } }
        }}
        nextField='driver_comment'
        alwaysInclude={isManualPriceRequired}
        required={isManualPriceRequired}
      />
    </Grid>
    <Grid hidden={estimation_type === 'special'} size={4}>
      <TextField
        label={I18n.t(`price.${estimation_type}`)}
        value={price || '-'}
        disabled
      />
    </Grid>
    <Grid hidden={estimation_type === 'special'} size={4}>
      <TextField
        label={I18n.t(`price.driver.${estimation_type}`)}
        value={driver_price || '-'}
        disabled
      />
    </Grid>
    <Grid hidden={estimation_type === 'special'} size={4}>
      <TextField
        label={I18n.t('voucher.voucher_amount')}
        value={voucher_amount || '-'}
        disabled
      />
    </Grid>
    <Grid size={2}>
      <TextComponent
        label={I18n.t('quotation.approach')}
        value={`${empty_fee} ${I18n.t('fiat.eur.sign')}`}
        disabled
      />
    </Grid>
    <Grid hidden={schedule_type === 'planned'} size={2}>
      <TextComponent
        label={I18n.t('transport.estimate_delay')}
        value={estimatedDelay || '-'}
        disabled
        InputProps={{
          startAdornment: !!isLiveETA ? <Icon>{'bolt'}</Icon> : <></>
        }}
      />
    </Grid>
  </Grid>

const Row2 = ({ pickup, distance, duration, margin, delayAtSource }) =>
  <Grid container spacing={1} size={12}>
    <Grid hidden={!margin} size={2}>
      <TextComponent
        label={I18n.t('traffic_alert.label', { count: 1 })}
        value={margin}
        disabled
      />
    </Grid>
    <Grid size={2}>
      <TextComponent
        label={I18n.t('order.delay_at_source')}
        value={_.isFinite(delayAtSource) ? `${delayAtSource}min` : '-'}
        disabled
      />
    </Grid>
    <Grid size={4}>
      <TextComponent
        label={I18n.t('transport.pickUp.user')}
        value={FormatUtils.formatDateBackToFront(pickup, 'DD/MM/YYYY [-] HH[h]mm')}
        disabled
      />
    </Grid>
    <Grid size={2}>
      <TextComponent
        label={I18n.t('distance.label', { count: 1 })}
        value={distance || 0}
        disabled
      />
    </Grid>
    <Grid size={2}>
      <TextComponent
        label={I18n.t('transport.estimate_duration')}
        value={duration || '-'}
        disabled
      />
    </Grid>
  </Grid>

const EstimationSection = props =>
  <Box sx={{ p: 1, borderRadius: 1, boxShadow: 6 }}>
    <Typography variant='h5' >{I18n.t('quotation.estimation')}</Typography>
    <Box sx={{ p: 1 }}>
      <Grid container rowSpacing={1.5}>
        <Row1 {...props} />
        <Row2 {...props} />
      </Grid>
    </Box>
  </Box>


export default React.memo(EstimationSection)
